import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

export class BaseService {
    constructor(protected http: HttpClient) { }

    protected delete<T>(
        url: string,
        queryParamsDictionary?: object,
        includeSubscriberJwtHeaders: boolean = true
    ): Observable<T> {
        if (queryParamsDictionary) {
            url += this.getQueryParams(queryParamsDictionary);
        }

        return this.http.delete<T>(url);
    }

    protected get<T>(url: string,
        queryParamsDictionary?: object,
    ): Observable<T> {
        if (queryParamsDictionary) {
            url += this.getQueryParams(queryParamsDictionary);
        }

        return this.http.get<T>(url);
    }

    protected post<T>(url: string,
        body?: object,
    ): Observable<T> {
        return this.http.post<T>(url, body);
    }
    protected update<T>(url: string,
        body?: object,
    ): Observable<T> {
        return this.http.put<T>(url, body);
    }
    private getQueryParams(queryParamsDictionary: any): string {
        const objKeys = Object.keys(queryParamsDictionary);
        if (!objKeys || objKeys.length === 0) {
            return '';
        }

        let paramString = '?';
        objKeys.forEach((key, i) => {
            paramString += `${key}=${queryParamsDictionary[key]}`;
            if (i !== objKeys.length - 1) {
                paramString += '&';
            }
        });

        return paramString;
    }

    protected handleError(error: any) {

        const applicationError = error.headers.get('Application-Error');

        if (applicationError) {
            return throwError(applicationError);
        }

        let modelStateErrors = '';

        for (const key in error.error) {
            if (error.error[key]) modelStateErrors += error.error[key].description + '\n';
        }

        modelStateErrors = modelStateErrors = '' ? null : modelStateErrors;
        return throwError(modelStateErrors || 'Server error');
    }

}
